import { BrowserRouter } from "react-router-dom";
import IncrementViews from "./components/Views/IncrementViews";

// Context Providers
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";

// Routes
import AppRoutes from "./routes/AppRoutes";

// Lyout 
import Layouts from "./layouts/Layouts";
 
const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <IncrementViews />
          <Layouts>
            <AppRoutes />
          </Layouts>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};


export default App 